import React from "react";
import PropTypes from "prop-types";
import { MenuButton } from "../styles";

ItalicButton.propTypes = {
  editor: PropTypes.object,
  disabled: PropTypes.bool,
};

export default function ItalicButton({ editor, disabled = false }) {
  return (
    <MenuButton
      onClick={() => editor.chain().focus().toggleItalic().run()}
      className={editor.isActive("italic") ? "is-active" : ""}
      disabled={disabled}
    >
      <span className="fas fa-italic" />
    </MenuButton>
  );
}
